import { BASE_URL } from '../constants'
import { apiSlice } from './apiSlice'

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        signup: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        sendOtp: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        verifyOtp: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        forgotPassword: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
    }),
})

export const { useLoginMutation, useSignupMutation, useSendOtpMutation, useVerifyOtpMutation, useForgotPasswordMutation } = usersApiSlice